import NullAttribute from './NullAttribute'

export default NullAttribute
